import { QuestionCategory, QuestionType, useGetMyQuestions } from "@/api/user/useGetMyQuestions";
import { hardcodedPersonalInfoQuestions } from "@/components/PersonalityTest/hardcoded-questions";
import { InfoBreakSlugs } from "@/components/shared/QuestionnaireFlow";
import { QuestionnaireFlowQuestion } from "@/types/question.types";
import { useMemo } from "react";

interface UseGetPersonalityTestQuestionsProps {
  isPersonalityTestOnly: boolean;
  enabled?: boolean;
}

export function useGetPersonalityTestQuestions({
  isPersonalityTestOnly,
  enabled = true,
}: UseGetPersonalityTestQuestionsProps) {
  const {
    data: questionsResponse,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useGetMyQuestions({ enabled });

  const questions = useMemo(() => {
    if (!questionsResponse) return [];

    const dynamicQuestions =
      questionsResponse.questions.filter((q) => q.category === "custom") || [];

    if (isPersonalityTestOnly) {
      return dynamicQuestions;
    }

    const postPersonalityTestInfoBreakQuestion: QuestionnaireFlowQuestion = {
      slug: InfoBreakSlugs.POST_PERSONALITY_TEST_INFO_BREAK,
      category: QuestionCategory.OTHER, // IRRELEVANT
      type: QuestionType.TEXT, // IRRELEVANT
      title: "", // IRRELEVANT
      extra: {},
    };

    const postIdentityTestInfoBreakQuestion: QuestionnaireFlowQuestion = {
      slug: InfoBreakSlugs.POST_IDENTITY_TEST_INFO_BREAK,
      category: QuestionCategory.OTHER, // IRRELEVANT
      type: QuestionType.TEXT, // IRRELEVANT
      title: "", // IRRELEVANT
      extra: {},
    };

    return [
      ...dynamicQuestions,
      postPersonalityTestInfoBreakQuestion,
      ...hardcodedPersonalInfoQuestions,
      postIdentityTestInfoBreakQuestion,
    ];
  }, [questionsResponse, isPersonalityTestOnly]);

  return { questions, isLoading, isError, isSuccess, error };
}
